export enum ArticleStatus {
  PUBLISHED = '1',
  DRAFT = '2',
}
